export default function Phase1() {
  return (
    <>
      <h2 className="cs-h2 cs-h2-tight">
        Phase 1: Social Media Marketing Strategy
      </h2>

      <h3 className="cs-h3">
       Platform Focus: Instagram & Facebook
      </h3>

      <p className="cs-p">
       Given Aruh Koncepts' visual product and target demographic, we prioritized Instagram as the primary brand-building platform with Facebook serving acquisition and retargeting functions.

      </p>

      <h3 className="cs-h3">
        Content Strategy Architecture
      </h3>

      <p className="cs-p">
       We developed a multi-format content ecosystem designed to educate, inspire, and qualify prospects while feeding Meta's Andromeda algorithm with signals for precision targeting:

      </p>

       <h3 className="cs-h3">
        User-Generated Content (UGC) Strategy

      </h3>

      <p className="cs-p">
            Systematic documentation of client experiences throughout project lifecycle: client testimonial videos captured on mobile devices for authentic feel, before-and-after walkthroughs narrated by homeowners, client unboxing and reveal reactions, homeowner giving property tours highlighting design details, and client testimonials discussing budget investment and value received.
            UGC served dual purposes: social proof for conversion and algorithm signals indicating high-value audience engagement. Content featuring satisfied clients discussing premium investments trained Meta to identify similar prospects.

      </p>

       <h3 className="cs-h3">
       Founder-Generated Content (FGC) Strategy
      </h3>

      <p className="cs-p">
            Positioned Aruh Koncepts' founders as design authorities and trusted advisors: founder presenting design philosophy and approach, behind-the-scenes content showing design process and material selection, educational content explaining design decisions and investment rationale, project reveal videos with founder narrating design story, and founder responding to common design questions and misconceptions.

           FGC established credibility and personal connection while subtly communicating the studio's premium positioning through production quality, design sophistication, and professional expertise.

      </p>

       <h3 className="cs-h3">
       Expert-Generated Content (EGC) Strategy
      </h3>

      <p className="cs-p">
           Technical and educational content demonstrating deep expertise: detailed breakdowns of specific design elements (lighting design, space planning, material selection), budget guidance for different project types with realistic investment ranges, design trend analysis relevant to Hyderabad market, technical explanations of construction and installation processes, and collaboration content featuring architects, contractors, and material suppliers.
            EGC content attracted serious prospects researching their projects while filtering out casual browsers through technical depth and budget transparency.

      </p>


       <h3 className="cs-h3">
       Content Distribution Framework
      </h3>

      <p className="cs-p">
           Instagram primary grid: High-quality project photography, portfolio showcases, major project reveals (3-4 posts per week).
            Instagram Reels: Short-form UGC, FGC, and EGC content optimized for reach and engagement (5-7 reels per week).
            Instagram Stories: Daily behind-the-scenes content, project updates, client interactions, polls and engagement features.
            Facebook: Cross-posted grid content plus longer-form educational posts, community building through design tips and inspiration.

      </p>


       <h3 className="cs-h3">
       Engagement & Community Building
      </h3>

      <p className="cs-p">
          Active response protocols to comments and DMs with qualification questions embedded, strategic engagement with Hyderabad real estate, architecture, and home improvement accounts, user-generated content encouragement through project hashtags and tagging incentives, and regular story features of client projects with permission.
      </p>




      {/* Entire Phase 1 content */}
    </>
  );
}